var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center gap-2"},[(_vm.image)?_c('v-img',{attrs:{"height":_vm.imageSize,"src":_vm.image,"width":_vm.imageSize,"contain":""}}):_vm._e(),(_vm.bold)?_c('h3',[_vm._v(_vm._s(_vm.$t(`tools.${_vm.name}`)))]):_c('span',[_vm._v(_vm._s(_vm.$t(`tools.${_vm.name}`)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }